import { CustomOffsetRecord, customOffsetToOption, hardcodedConfirmationOffsets } from '@shared/core/custom-offsets'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useConfirmationOffsets(options?: UseQueryOptions<CustomOffsetRecord[]>) {
  const { data: customOffsets = [] } = useQuery<CustomOffsetRecord[]>(
    ['custom-offsets', 'confirmation'],
    () => ApiService.CustomOffsets.getCustomOffsets('confirmation'),
    {
      staleTime: ms('5 minutes'),
      ...options,
    },
  )
  const allOptions = [
    ...hardcodedConfirmationOffsets,
    ...customOffsets.map((offset) => customOffsetToOption(offset, 'confirmation')),
  ]
  allOptions.sort((a, b) => Number(a.value) - Number(b.value))
  return allOptions
}
